/**
 * Closes all open PrimeReact overlays (dropdowns, multiselects, panels, etc.)
 * Useful when closing modals with open dropdowns
 */
export const closeAllOverlays = () => {
  // Close PrimeReact MultiSelect dropdowns and related elements
  document.querySelectorAll('.p-multiselect-items-wrapper').forEach((el) => {
    el.style.display = 'none';
  });
  document.querySelectorAll('.p-multiselect-panel').forEach((el) => {
    el.style.display = 'none';
  });

  // Close PrimeReact Dropdown menus and related elements
  document.querySelectorAll('.p-dropdown-items-wrapper').forEach((el) => {
    el.style.display = 'none';
  });
  document.querySelectorAll('.p-dropdown-panel').forEach((el) => {
    el.style.display = 'none';
  });
  document.querySelectorAll('.p-dropdown-items').forEach((el) => {
    el.style.display = 'none';
  });

  // Close PrimeReact OverlayPanels
  document.querySelectorAll('.p-overlaypanel').forEach((el) => {
    el.style.display = 'none';
  });

  // Close PrimeReact Menus
  document.querySelectorAll('.p-menu').forEach((el) => {
    el.style.display = 'none';
  });

  // Close PrimeReact Autocomplete suggestions
  document.querySelectorAll('.p-autocomplete-list').forEach((el) => {
    el.style.display = 'none';
  });
  document.querySelectorAll('.p-autocomplete-panel').forEach((el) => {
    el.style.display = 'none';
  });

  // Close any element with data-pc-name='overlaypanel' or similar
  document.querySelectorAll('[data-pc-name="overlaypanel"]').forEach((el) => {
    el.style.display = 'none';
  });

  // Close any remaining overlay-like elements (positioned absolutely/fixed with z-index)
  document.querySelectorAll('.p-connected-overlay-enter-active').forEach((el) => {
    el.style.display = 'none';
  });
  document.querySelectorAll('.p-connected-overlay').forEach((el) => {
    el.style.display = 'none';
  });
};
